export const COOKIE_LOCALE_KEY = "FARADARS_LOCALE";
export const NEXT_LOCALE_KEY = "NEXT_LOCALE";
export const COOKIE_REFRESH_TOKEN_KEY = "FA_REFRESH_TOKEN";
export const COOKIE_ACCESS_TOKEN_KEY = "FA_ACCESS_TOKEN";
export const COOKIE_FRONT_TOKEN_KEY = "FRONT_TOKEN";
export const COOKIE_SHOW_ANDROID_APP = "SHOW_ANDROID_APP";
export const COOKIE_SHOPPING_CART = "shopping_cart";
export const COOKIE_SHOW_SUBSCRIPTION_BANNER = "SHOW_SUBSCRIPTION_BANNER";

export const COOKIE_EXPIRATION_TIME = 365;
export const COOKIE_NOT_FIRST_USE = "FA_NOT_FIRST_USE";
export const COOKIE_EVENT_TIMER = "FA_EVENT_TIMER";

export const AUTHENTICATION_URL = "/signin";
export const COLLECTION_URL = "/how-to-learning";
export const SITE_URL = "https://faradars.org";
export const SITE_ORIGIN =
  process.env.NEXT_PUBLIC_SITE_ORIGIN || new URL(SITE_URL).origin;
export const CALLBACK_URL = "https://faradars.org/api/linkedin";
export const ORGANIZATION_URN = "urn:li:organization:18328476";
export const ORGANIZATION_ID = "18328476";
export const BRAND_NAME = "Faradars";
export const SITE_NAME = "Faradars";
export const SITE_NAME_FA = "فرادرس";
export const COPY_RIGHT = "©فرادرس ۱۳۸۷-۱۴۰۲.";
export const BLOG_URL = "https://blog.faradars.org/";
export const COPY_RIGHT_OWNER = " تمام حقوق متعلق به «کلان دانش سهند» است.©";
export const APP_REDIRECT_DOWNLOAD_URL =
  "https://faradars.org/api/client/v1/download/application?type=android";

export const APP_NAME = "فرادرس";
export const APP_URL = "faradars://faradars.org";
export const APP_GOOGLE_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=org.faradars.app&utm_source=faradars.org&utm_campaign=app_dl_page&pli=1";

export const APP_PACKAGE_NAME = "org.faradars.app";

export const BOTS =
  "(googlebot|postman|bingbot|yandex|Mediapartners-Google|baiduspider|twitterbot|TelegramBot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest/0\\.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp|Googlebot\\/2\\.1|Mobile-specific strings|Googlebot-Image\\/1\\.0|Googlebot-News|Googlebot-Video\\/1\\.0|AdsBot-Google|Googlebot-Favicon|Web Light|APIs-Google|duplexWeb-Google|Storebot-Google|Google-Read-Aloud|Feedfetcher-Google)";

// "(googlebot|postman|bingbot|yandex|Mediapartners-Google|baiduspider|twitterbot|TelegramBot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest/0.|pinterestbot|slackbot|vkShare|W3C_Validator|whatsapp)";

export const BOTS2 =
  "(googlebot|Mozilla|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";

export const DEFAULT_COMMENT_PAGE_LIMIT = 10;

export const VISITING_STATUS_LOCAL_STORAGE_KEY = "access-visiting-status";

export const FRDS_CHAT_ELEMENT_ID = "fdrs-chat-widget";

export const SNAP_PAY_AMOUNT = 1_000_000;
export const IFRAME_URLS = [
  "https://docs.google.com/",
  "https://phet.colorado.edu/",
  "https://static.fdrs.ir",
  "https://job.faradars.org",
];

export const MAIN_TITLE_SITE =
  "فرادرس – آموزش‌های ویدئویی کاربردی،‌ مهارتی،‌ تخصصی و دانشگاهی";
